import * as React from "react";
import Select from "@8x8/oxygen-select";

import FullWidthDiv from "@/react/features/styled/FullWidthDiv";
import { CopyButton } from "@/react/components/CopyButton";

import { KeyLabel, Row, RowContent } from "./styled";

const SelectRow = ({
  options,
  renderIcon,
  labelText,
  getValueToCopy,
  placeholderText,
  currentSelection,
  onSelectionChange,
  menuPortalTarget,
  selectorTestId,
}) => {
  return (
    <Row>
      {renderIcon && renderIcon()}
      <KeyLabel>{labelText}</KeyLabel>
      <RowContent>
        <FullWidthDiv>
          {/* NOTE: Oxygen will append _VALUE_CONTAINER to the test-id we provide */}
          <Select
            isDisabled={options?.length === 0}
            placeholder={placeholderText ?? "No selection."}
            onChange={onSelectionChange}
            options={options}
            value={currentSelection}
            isClearable={false}
            menuPortalTarget={menuPortalTarget}
            testId={selectorTestId}
          />
        </FullWidthDiv>
        <CopyButton value={getValueToCopy(currentSelection)} />
      </RowContent>
    </Row>
  );
};

export default SelectRow;
